import api from "../../utils/api/Axios";
import { APICONSTANT } from "../../utils/api/Config";
import type { VisualizationResponse } from "../types";

/**
 * Generates a visualization query by calling the backend AI proxy.
 * This prevents exposing the Gemini API key in the client-side bundle.
 */
export async function generateVisualization(
  userQuery: string
): Promise<VisualizationResponse> {
  try {
    // Calling the backend endpoint which will handle the Gemini API request securely
    const response = await api.post(APICONSTANT.aiRemarkSubmit, {
      query: userQuery,
    });

    // The backend should return the structured response
    const parsedResponse = response as unknown as VisualizationResponse;

    // Basic validation
    if (
      !parsedResponse.title ||
      !parsedResponse.chart_type ||
      !parsedResponse.sql_query
    ) {
      throw new Error("Invalid response format from API.");
    }

    return parsedResponse;
  } catch (error) {
    console.error("Error fetching AI visualization:", error);
    throw new Error("Failed to get a valid response from the AI assistant.");
  }
}
